// eslint-disable-next-line import/extensions
import hostList from "./api_host.js";

// 測試
const BASE_URL = `${hostList.PRIVATE_HOST}/Ant_API/api`;

// 正式
// const BASE_URL = "http://anshinescrow-lb.januarytc.com";

const ApiUrl = {
  //https://anshinescrow-dev.januarytc.com/Ant_API/api/idcheck/getverifystatus
  // 取得取得身分證最近驗證結果
  idcheckgetverifystatus: `${BASE_URL}/idcheck/getverifystatus`,
  // 支票票號查詢
  contractmaintaingetbillverifyresult: `${BASE_URL}/contractmaintain/getbillverifyresult`,
  // 身份驗證/驗證身分證 / 身分證OCR辨識API
  idcheckrecognizeidcard: `${BASE_URL}/idcheck/recognizeidcard`,
  // 身份驗證/驗證身分證 / 內政部身分證驗證API (內政部民政司)
  idcheckrisverifyid: `${BASE_URL}/idcheck/risverifyid`,

  outcheckmaintaingetoutchecklist: `${BASE_URL}/outcheckmaintain/getoutchecklist`,
  // 收出款作業/出款確認維護 / 送出前資料驗證(按下"確認出款"時必須先呼叫)
  outcheckmaintainoutchecksubmit_datacheck: `${BASE_URL}/outcheckmaintain/outchecksubmit_datacheck`,
  // 收出款作業/出款確認維護 / 出款確認 + 傳票產生
  outcheckmaintainoutchecksubmit_datasave: `${BASE_URL}/outcheckmaintain/outchecksubmit_datasave`,
  // 收出款作業/出款確認維護 / 取得頁面控件資料
  outcheckmaintaingetinputlist: `${BASE_URL}/outcheckmaintain/getinputlist`,

  // 收出款作業 / 履保費用明細表 / 履保費用明細表
  piamtreportreport: `${BASE_URL}/piamtreport/report`,

  // 收出款作業 / 退匯重匯作業 / 退匯重匯作業產製txt 檔
  // eslint-disable-next-line no-dupe-keys
  speialrefundrefund_data_product: `${BASE_URL}/speialrefund/refund_data_product`,
  // 收出款作業 / 退匯重匯作業 / 退匯重匯資料內容明細
  speialrefundqrefund_content_detail: `${BASE_URL}/speialrefund/qrefund_content_detail`,
  // 收出款作業 / 退匯重匯作業 / 查詢退匯歷程
  speialrefundqrefund_content_history: `${BASE_URL}/speialrefund/qrefund_content_history`,
  // 收出款作業 / 退匯重匯作業 / 查詢退匯重匯款項
  speialrefundspeial_refund_querym: `${BASE_URL}/speialrefund/speial_refund_querym`,

  // 代書資料維護 仲介資料維護 分級
  npu12autotranslevel: `${BASE_URL}/npu12/autotranslevel`,

  // DashBoard/檢查買方為法人/檢查買方為法人列表
  npccontractmanb: `${BASE_URL}/api-npc-contractman-b`,
  // DashBoard/檢查買方為法人/檢查貸款銀行列表
  contractdatabuybanklimit: `${BASE_URL}/api-contractdata-buybank-limit`,
  // DashBoard/檢查買方為法人,貸款銀行/修改檢查買方為法人或檢查貸款銀行 確認人員
  investigateedit: `${BASE_URL}/api-investigate-edit`,

  // 信託專區/APTOAP收款維護/詳細-列表頁
  npu050200001a: `${BASE_URL}/api-npu050200-001-a`,
  // 信託專區/APTOAP收款維護/詳細-列表頁(入賬/合併入賬)
  npu050200001b: `${BASE_URL}/api-npu050200-001-b`,
  // 信託專區/APTOAP收款維護/詳細-列表頁(交屋入帳)
  npu050200001c: `${BASE_URL}/api-npu050200-001-c`,
  // 信託專區/APTOAP收款維護/入帳/合併入帳-入賬寫入
  npu050200003a: `${BASE_URL}/api-npu050200-003-a`,
  // 信託專區/APTOAP收款維護/交屋入帳-入賬寫入
  npu050200003b: `${BASE_URL}/api-npu050200-003-b`,
  // 信託專區/APTOAP收款維護/入袋解款(待入帳區)
  npu050200003c: `${BASE_URL}/api-npu050200-003-c`,
  // 信託專區/APTOAP收款維護/存檔
  npu050200003d: `${BASE_URL}/api-npu050200-003-d`,
  // 信託專區/APTOAP收款維護/刪除資料
  npu050200004a: `${BASE_URL}/api-npu050200-004-a`,
  // 信託專區/APTOAP收款維護/入待入帳
  npu050200004b: `${BASE_URL}/api-npu050200-004-b`,
  // 信託專區/APTOAP收款維護/特殊入賬-入賬寫入
  npu050200004c: `${BASE_URL}/api-npu050200-004-c`,

  // 合約管理/合約資料維護/取得頁面選單資料 v
  contractmaintaingetinputslist: `${BASE_URL}/contractmaintain/getinputslist`,
  // 合約管理/合約資料維護/取得主表查詢資料 v
  contractmaintaingetresultlist: `${BASE_URL}/contractmaintain/getresultlist`,
  // 合約管理/合約資料維護/取得合約維護明細資料 v
  contractmaintaingetdetaillist: `${BASE_URL}/contractmaintain/getdetaillist`,
  // 合約管理/合約資料維護/業績分配表 (0608) v
  contractmaintaingetrpt0608: `${BASE_URL}/contractmaintain/getrpt0608`,
  // 合約管理/合約資料維護/授權書 (0609) v
  contractmaintaingetrpt0609: `${BASE_URL}/contractmaintain/getrpt0609`,
  // 合約管理/合約資料維護/專戶資金控管表 (0601) 未用
  contractmaintaingetrpt0601: `${BASE_URL}/contractmaintain/getrpt0601`,
  // 合約管理/合約資料維護/高價表單列印 v
  contractmaintaindownload: `${BASE_URL}/contractmaintain/download`,
  // 合約管理/合約資料維護/取得新增合約申請時，預先載入的欄位資訊 v basic
  contractmaintaingetpreloadlist: `${BASE_URL}/contractmaintain/getpreloadlist`,
  // 合約管理/合約資料維護/取得保證書GuaranteeID v
  contractmaintaingetguaranteeid: `${BASE_URL}/contractmaintain/getguaranteeid`,
  // 合約管理/合約資料維護/買賣方身分證、統一編號驗證
  contractmaintaintwidchecker: `${BASE_URL}/contractmaintain/twidchecker`,
  // 合約管理/合約資料維護/新增
  contractmaintainaddition: `${BASE_URL}/contractmaintain/addition`,
  // 合約管理/合約資料維護/修改
  contractmaintainupdation: `${BASE_URL}/contractmaintain/updation`,
  // 合約管理/合約資料維護/請款修改 (只有07可用)
  contractmaintaininvoicemodify: `${BASE_URL}/contractmaintain/invoicemodify`,
  // 合約管理/合約資料維護/取得承辦代書特殊備註 v
  contractmaintaingetwritelegalspcdesc: `${BASE_URL}/contractmaintain/getwritelegalspcdesc`,
  // 合約管理/合約資料維護/買賣方個人聯絡資料
  contractmaintaingetcontactmandetaillist: `${BASE_URL}/contractmaintain/getcontactmandetaillist`,
  // 合約管理/合約資料維護/仲介商紅字說明 1111
  contractmaintaingetbrandstorespecialtext: `${BASE_URL}/contractmaintain/getbrandstorespecialtext`,
  // 合約管理/合約資料維護/(代書相關)取得代書聯絡人 1111
  contractmaintaingetwritelegalassistant: `${BASE_URL}/contractmaintain/getwritelegalassistant`,
  // 合約管理/合約資料維護/(代書相關)取得代書習慣相關資訊 (新增修改時，使用者選擇/異動代書編號時呼叫)
  contractmaintaingetwritelegalhabitspc: `${BASE_URL}/contractmaintain/getwritelegalhabitspc`,
  // 合約管理/合約資料維護/(仲介商相關)取得仲介商習慣相關資訊 (1. 新增修改時，使用者選擇/異動仲介商編號時呼叫；2. result.REMARK若有值，請取出作為提示訊息(暫定))
  contractmaintaingetbrandstorehabitspc: `${BASE_URL}/contractmaintain/getbrandstorehabitspc`,

  // https://anshinescrow-dev.januarytc.com/Ant_API/api/contractmaintain/getbrandstorehabitspc
  // 收出款作業/指示書作業/取得信託銀行資料
  instructionmaintaingettrustbanklist: `${BASE_URL}/instructionmaintain/gettrustbanklist`,
  // 收出款作業/指示書作業/頁面控件
  instructionmaintaingetinputslist: `${BASE_URL}/instructionmaintain/getinputslist`,
  // 收出款作業/指示書作業/取得"未產製"指示書 申請書資料
  instructionmaintaingetawaitinglist: `${BASE_URL}/instructionmaintain/getawaitinglist`,
  // 收出款作業/指示書作業/未產製"之指示書產製、寄送
  instructionmaintainawaitingdispatch: `${BASE_URL}/instructionmaintain/awaitingdispatch`,
  // 收出款作業/指示書作業/取得"已產製"指示書 申請書資料
  instructionmaintaingetproducedlist: `${BASE_URL}/instructionmaintain/getproducedlist`,
  // 收出款作業/指示書作業/指示書日統計表(PDF匯出)
  instructionmaintaingetinstructiondailyreport: `${BASE_URL}/instructionmaintain/getinstructiondailyreport`,
  // 收出款作業/指示書作業/指示書日報表 寄送
  instructionmaintaindailyreportdispatch: `${BASE_URL}/instructionmaintain/dailyreportdispatch`,
  // 收出款作業/指示書作業/已產製" 資料列表"出款明細查詢" 參數只帶"CheckUserID
  instructionmaintaingetoutresultdetaillist: `${BASE_URL}/instructionmaintain/getoutresultdetaillist`,
  // 收出款作業/指示書作業/按下補通訊指示書按鈕時，預載資訊到指示書填寫頁面
  instructionmaintainsupplementpreload: `${BASE_URL}/instructionmaintain/supplementpreload`,
  // 收出款作業/指示書作業/已產製" 出款狀態明細之補通訊指示書 產製、寄送
  instructionmaintainsupplementdispatch: `${BASE_URL}/instructionmaintain/supplementdispatch`,

  // 收出款作業/撤退票指示書/頁面控件
  billinfoinstructiongetinputslist: `${BASE_URL}/billinfoinstruction/getinputslist`,
  // 收出款作業/撤退票指示書/取得撤退票 主表資料
  billinfoinstructiongetbillinstructionlist: `${BASE_URL}/billinfoinstruction/getbillinstructionlist`,
  // 收出款作業/撤退票指示書/產製退票指示書
  billinfoinstructionrevocationdispatch: `${BASE_URL}/billinfoinstruction/revocationdispatch`,

  // 信託專區/信託專戶設定/查詢信託專戶
  accountsetsettingaccountsetquerym: `${BASE_URL}/accountsetsetting/accountsetquerym`,
  // 信託專區/信託專戶設定/公司行號選項
  accountsetsettinggetcompany: `${BASE_URL}/accountsetsetting/getcompany`,
  // 信託專區/信託專戶設定/專戶資料新增、修改、停用
  accountsetsettingaccount_set_data_change: `${BASE_URL}/accountsetsetting/account_set_data_change`,

  // 信託專區/簡訊重補發作業/列表頁
  npu050800001: `${BASE_URL}/api-npu050800-001`,
  // 信託專區/簡訊重補發作業/詳細表
  npu050800001a: `${BASE_URL}/api-npu050800-001-a`,
  // 信託專區/簡訊重補發作業/發送
  npu050800003a: `${BASE_URL}/api-npu050800-003-a`,

  // L-共用功能鎖定/共用 鎖定＆解鎖動作
  locklockaction: `${BASE_URL}/lock/lockaction`,
  // L-共用功能鎖定/取得頁面承辦窗口清單
  lockgetundertakeuserlist: `${BASE_URL}/lock/getundertakeuserlist`,

  // 信託專區/APTOAP收款維護/小鈴鐺列表
  npu050200001d: `${BASE_URL}/api-npu050200-001-d`,
  // 信託專區/APTOAP收款維護/更改小鈴鐺狀態
  npu050200003e: `${BASE_URL}/api-npu050200-003-e`,
  // 信託專區/APTOAP收款維護/列表頁
  npu050200001: `${BASE_URL}/api-npu050200-001`,

  // A-共用/取得銀行帳戶
  contractaccount001: `${BASE_URL}/api-contractaccount-001`,

  // 收出款作業/出款申請書維護/取得特殊新增-款項列表
  outapplicationformgetspecial_collecttype: `${BASE_URL}/outapplicationform/getspecial_collecttype`,

  // 收出款作業/出款申請書維護/保留款立帳維護 - 款項特殊修改【確定修改】
  outapplicationformout_money_detail_change: `${BASE_URL}/outapplicationform/out_money_detail_change`,
  // 收出款作業/出款申請書維護/出款申請書-保留款立帳維護
  outapplicationformout_money_detail: `${BASE_URL}/outapplicationform/out_money_detail`,

  // 收出款作業/出款申請書維護/匯款明細維護 （履保）
  outapplicationformremittancedetails: `${BASE_URL}/outapplicationform/remittancedetails`,
  // 收出款作業/出款申請書維護/匯款明細維護 修改
  outapplicationformremittancedetailsedit: `${BASE_URL}/outapplicationform/remittancedetailsedit`,

  // 收出款作業/出款申請書維護/匯出付款申請書+Txt
  outapplicationformexport: `${BASE_URL}/outapplicationform/export`,
  // 收出款作業/出款申請書維護/付款申請書產生前檢查
  outapplicationformget_check_istransfer: `${BASE_URL}/outapplicationform/get_check_istransfer`,
  // 收出款作業/出款申請書維護/出款申請書維護明細 search
  outapplicationformfunds_detail_querym: `${BASE_URL}/outapplicationform/funds_detail_querym`,

  // 信託專區/利息差異表/
  interestdifftableexcel: `${BASE_URL}/api-interestdifftable-excel`,

  // 信託專區/出款狀態手動上傳/出款狀態手動上傳
  manualupload005: `${BASE_URL}/api-manualupload-005`,

  // 信託專區/協議動用出款確認/列表頁
  npu050900001: `${BASE_URL}/api-npu050900-001`,
  // 信託專區/協議動用出款確認/詳細頁
  npu050900001a: `${BASE_URL}/api-npu050900-001-a`,
  // 信託專區/協議動用出款確認/儲存
  npu050900003a: `${BASE_URL}/api-npu050900-003-a`,

  // 數位看板/看板主查詢/取得看板最新資訊
  signagesignagemainlist: `${BASE_URL}/signage/signagemainlist`,

  // 收出款作業/收款審核維護共用/UpdateData 鎖定區域 共用
  npu050400common: `${BASE_URL}/api-npu050400-common`,

  // 收出款作業/收款審核維護/確認審核
  npu050400003a: `${BASE_URL}/api-npu050400-003a`,
  // 收出款作業/收款審核維護/詳細-列表頁
  npu050400001a: `${BASE_URL}/api-npu050400-001-a`,

  // 收出款作業/收款傳票維護/列表頁
  npu050500001: `${BASE_URL}/api-npu050500-001`,
  // 收出款作業/收款傳票維護/產生傳票
  npu050500003a: `${BASE_URL}/api-npu050500-003a`,
  // 收出款作業/收款傳票維護/詳細-列表頁
  npu050500001a: `${BASE_URL}/api-npu050500-001-a`,

  // 收出款作業/出款狀態查詢/取得下拉式選單資料
  outresultgetinputlist: `${BASE_URL}/outresult/getinputlist`,
  // 收出款作業/出款狀態查詢/取得主要列表資料
  outresultgetresultlist: `${BASE_URL}/outresult/getresultlist`,
  // 收出款作業/出款狀態查詢/按下補通訊指示書按鈕時，預載資訊到指示書填寫頁面
  outresultdispatch_preload: `${BASE_URL}/outresult/dispatch_preload`,
  // 收出款作業/出款狀態查詢/產製指示書並寄送
  outresultdispatch: `${BASE_URL}/outresult/dispatch`,

  // 收出款作業/收出款修改維護/查詢合約
  updatefundsupdate_funds_querym: `${BASE_URL}/updatefunds/update_funds_querym`,
  // 收出款作業/收出款修改維護/取得單筆資料給收出款修改維護的表格填入
  updatefundsupdate_funds_queryd: `${BASE_URL}/updatefunds/update_funds_queryd`,
  // 收出款作業/收出款修改維護/刪除和特殊刪除功能
  updatefundsupdate_funds_delete: `${BASE_URL}/updatefunds/update_funds_delete`,

  // 合約發放作業-代書庫存匯出
  npu030100001plus: `${BASE_URL}/api-npu030100-001-plus`,

  // 收出款作業/新增收出款項/查詢合約
  addfundsadd_funds_querym: `${BASE_URL}/addfunds/add_funds_querym`,
  // 收出款作業/新增收出款項/專戶資金控管表
  addfundsreport: `${BASE_URL}/addfunds/report`,
  // 收出款作業/新增收出款項/新增收出款項存檔 (異常狀態、注意事項)欄位修改
  addfundsadd_funds_change: `${BASE_URL}/addfunds/add_funds_change`,
  // 收出款作業/新增收出款項/取得收款列表
  addfundsreceipt_detail_querym: `${BASE_URL}/addfunds/receipt_detail_querym`,
  // 收出款作業/新增收出款項/取得單筆收款明細項目
  addfundsreceipt_detail_queryd: `${BASE_URL}/addfunds/receipt_detail_queryd`,
  // 收出款作業/新增收出款項/收款明細項目新增、修改、刪除
  addfundsreceipt_data_update: `${BASE_URL}/addfunds/receipt_data_update`,
  // 收出款作業/新增收出款項/取得出款列表
  addfundsout_detail_querym: `${BASE_URL}/addfunds/out_detail_querym`,
  // 收出款作業/新增收出款項/取得單筆出款明細項目
  addfundsout_detail_queryd: `${BASE_URL}/addfunds/out_detail_queryd`,
  // 收出款作業/新增收出款項/出款明細項目新增、修改、刪除
  addfundsout_data_update: `${BASE_URL}/addfunds/out_data_update`,
  // 收出款作業/新增收出款項/出款帳號查詢
  addfundsout_account_data_querym: `${BASE_URL}/addfunds/out_account_data_querym`,

  // 合約管理/專戶結清作業/取得專戶結清列表
  npu040700001: `${BASE_URL}/api-npu040700-001`,
  // 合約管理/專戶結清作業/取得專戶結清詳細頁
  npu040700001a: `${BASE_URL}/api-npu040700-001-a`,
  // 合約管理/專戶結清作業/手動上傳結案單
  npu040700005a: `${BASE_URL}/api-npu040700-005-a`,
  // 合約管理/專戶結清作業/列印結案單
  npu040700005b: `${BASE_URL}/api-npu040700-005-b`,
  // 合約管理/專戶結清作業/上傳結案單
  npu040700005c: `${BASE_URL}/api-npu040700-005-c`,
  // 合約管理/專戶結清作業/發送電子郵件
  npu040700005d: `${BASE_URL}/api-npu040700-005-d`,
  // 合約管理/專戶結清作業/試算專戶餘額 1(需加2)
  npu040700006a: `${BASE_URL}/api-npu040700-006-a`,
  // 合約管理/專戶結清作業/試算專戶餘額2  專戶結清
  npu040700006b: `${BASE_URL}/api-npu040700-006-b`,
  // 合約管理/專戶結清作業/匯款明細修改
  npu040700006c: `${BASE_URL}/api-npu040700-006-c`,
  // 合約管理/專戶結清作業/取消結清1  (需加2)
  npu040700006d: `${BASE_URL}/api-npu040700-006-d`,
  // 合約管理/專戶結清作業/取消結清2
  npu040700006e: `${BASE_URL}/api-npu040700-006-e`,

  // 報表管理/個案動態追蹤表/查詢列表
  npu062500search: `${BASE_URL}/npu062500/search`,
  // 報表管理/個案動態追蹤表/預覽單筆報表
  npu062500siglereport: `${BASE_URL}/npu062500/siglereport`,
  // 報表管理/個案動態追蹤表/取得選擇匯出欄位選項
  npu062500getexportitemlist: `${BASE_URL}/npu062500/getexportitemlist`,
  // 報表管理/個案動態追蹤表/匯出
  npu062500export: `${BASE_URL}/npu062500/export`,

  // 報表管理/票據資訊一覽表/產生報表
  npu061900report: `${BASE_URL}/npu061900/report`,

  // 報表管理/品牌送件統計表/產生報表
  npu061300report: `${BASE_URL}/npu061300/report`,

  // 報表管理/契約資訊一覽表/產生報表
  npu060600report: `${BASE_URL}/npu060600/report`,

  // 報表管理/專戶餘額日報表/取得專戶下拉選項
  npu060400getoptions: `${BASE_URL}/npu060400/getoptions`,
  // 報表管理/專戶餘額日報表/產生報表
  npu060400report: `${BASE_URL}/npu060400/report`,

  // 報表管理/專戶控管資金表/產生報表
  npu060100report: `${BASE_URL}/npu060100/report`,

  // 合約管理/結案作業/案件誤開結案 unused
  npu040800clearover: `${BASE_URL}/npu040800/clearover`,
  // 合約管理/結案作業/查詢
  npu040800search: `${BASE_URL}/npu040800/search`,
  // 合約管理/結案作業/專案結案
  npu040800caseclose: `${BASE_URL}/npu040800/caseclose`,
  // 合約管理/結案作業/取得明細資料
  npu040800details: `${BASE_URL}/npu040800/details`,
  // 合約管理/結案作業/取得仲介商資料指定代碼
  npu040800getbranchstoredata: `${BASE_URL}/npu040800/getbranchstoredata`,
  // 合約管理/結案作業/確定修改
  npu040800savedata: `${BASE_URL}/npu040800/savedata`,

  // 合約管理/日結專戶餘額維護/執行日結維護
  npu040900run: `${BASE_URL}/npu040900/run`,

  // 合約管理/合約件數月結/取得最後月結年月
  npu041400getlastdate: `${BASE_URL}/npu041400/getlastdate`,
  // 合約管理/合約件數月結/取消月結
  npu041400runcancel: `${BASE_URL}/npu041400/runcancel`,
  // 合約管理/合約件數月結/執行月結
  npu041400runupdate: `${BASE_URL}/npu041400/runupdate`,

  // 合約管理/合約件數日結/執行日結維護
  npu041200run: `${BASE_URL}/npu041200/run`,
  // 合約管理/日結維護/執行日結維護
  npu040600run: `${BASE_URL}/npu040600/run`,

  // 合約發放作業/住商回報表/匯出報表
  npu062100001aa: `${BASE_URL}/api-npu062100-001-aa`,
  // 合約發放作業/住商回報表/人工寄送
  npu062100001ab: `${BASE_URL}/api-npu062100-001-ab`,
  // 合約發放作業/住商回報表/設定email選單
  npu062100001a: `${BASE_URL}/api-npu062100-001-a`,
  // 合約發放作業/住商回報表/修改email
  npu062100003: `${BASE_URL}/api-npu062100-003`,

  // 代理訪問其他網頁API
  proxyoutsideapi: `${BASE_URL}/proxyoutsideapi`,

  // 合約發放作業/合約發放作業/合約申請與查詢/取得自動審核參數主表資料
  contractapplygetapplyparamsresultlist: `${BASE_URL}/contractapply/getapplyparamsresultlist`,
  // 合約發放作業/合約發放作業/合約申請與查詢/取得自動審核參數主表資料
  contractapplymodification: `${BASE_URL}/contractapply/modification`,

  // 基本資料維護/實際承辦、實際業務維護/匯出代書資料
  npu122400001aa: `${BASE_URL}/api-npu122400-001-aa`,
  // 基本資料維護/實際承辦、實際業務維護/匯入資料
  npu122400001ab: `${BASE_URL}/api-npu122400-001-ab`,

  // 合約發放作業/合約寄送作業/取得頁面輸入控件資料
  contractsendgetinputslist: `${BASE_URL}/contractsend/getinputslist`,
  // 合約發放作業/合約寄送作業/取得合約申請"已審核"清單資料
  contractsendgetresultlist: `${BASE_URL}/contractsend/getresultlist`,
  // 合約發放作業/合約寄送作業/取得申請編號明細資料
  contractsendgetdetaillist: `${BASE_URL}/contractsend/getdetaillist`,
  // 合約發放作業/合約寄送作業/匯出合約寄送資料 (Excel)
  contractsenddownload: `${BASE_URL}/contractsend/download`,
  // 合約發放作業/合約寄送作業/更新合約資料
  contractsendupdation: `${BASE_URL}/contractsend/updation`,
  // 合約發放作業/合約寄送作業/寄送信件 (Dispatch)
  contractsenddispatch: `${BASE_URL}/contractsend/dispatch`,
  // 合約發放作業/合約寄送作業/發送簡訊 (Transmit)
  contractsendtransmit: `${BASE_URL}/contractsend/transmit`,

  // 合約發放作業/合約申請與查詢/取得頁面輸入控件資料
  contractapplygetinputslist: `${BASE_URL}/contractapply/getinputslist`,
  // 合約發放作業/合約申請與查詢/取得合約申請資料
  contractapplygetresultlist: `${BASE_URL}/contractapply/getresultlist`,
  // 合約發放作業/合約申請與查詢/取得申請編號明細資料
  contractapplygetdetaillist: `${BASE_URL}/contractapply/getdetaillist`,
  // 合約發放作業/合約申請與查詢/取得代書庫存查詢資料
  contractapplygetstocksresultlist: `${BASE_URL}/contractapply/getstocksresultlist`,
  // 合約發放作業/合約申請與查詢/取得代書庫存單一明細資料
  contractapplygetstocksdetaillist: `${BASE_URL}/contractapply/getstocksdetaillist`,
  // 合約發放作業/合約申請與查詢/取得新增合約申請時
  contractapplyprovision: `${BASE_URL}/contractapply/provision`,
  // 合約發放作業/合約申請與查詢/新增合約申請資料
  contractapplyaddition: `${BASE_URL}/contractapply/addition`,
  // 合約發放作業/合約申請與查詢/修改合約申請資料
  contractapplyupdation: `${BASE_URL}/contractapply/updation`,
  // 合約發放作業/合約申請與查詢/刪除合約申請資料
  contractapplydeletion: `${BASE_URL}/contractapply/deletion`,

  // 合約發放作業/代書端庫存匯出/查詢匯出
  npu141000export: `${BASE_URL}/npu141000/export`,

  // 合約發放作業/合約代書維護/查詢列表
  npu040510getlist: `${BASE_URL}/npu040510/getlist`,
  // 合約發放作業/合約代書維護/合約代書修改
  npu040510edit: `${BASE_URL}/npu040510/edit`,

  // 合約發放作業/合約歷程查詢/查詢列表
  npu041800getsearchlist: `${BASE_URL}/npu041800/getsearchlist`,
  // 合約發放作業/合約歷程查詢/合約歷程紀錄列表
  npu041800gethistorylist: `${BASE_URL}/npu041800/gethistorylist`,

  // 合約發放作業/合約回收作廢/查詢列表
  grantcontractrecyclegetlist: `${BASE_URL}/grantcontractrecycle/getlist`,
  // 合約發放作業/合約回收作廢/回收合約查詢列表
  grantcontractrecycleedit_search: `${BASE_URL}/grantcontractrecycle/edit_search`,
  // 合約發放作業/合約回收作廢/作廢合約總表匯出
  grantcontractrecycleexport: `${BASE_URL}/grantcontractrecycle/export`,
  // 合約發放作業/合約回收作廢/執行回收/作廢
  grantcontractrecycleexecute: `${BASE_URL}/grantcontractrecycle/execute`,

  // 合約發放作業/合約發放作業/default 列表 信託銀行、存款銀行
  npu040200001a00: `${BASE_URL}/api-npu040200-001-a00`,
  // 合約發放作業/合約發放作業/代書查詢
  npu040200001a: `${BASE_URL}/api-npu040200-001-a`,
  // 合約發放作業/合約發放作業/申請單號查詢
  npu040200001b: `${BASE_URL}/api-npu040200-001-b`,
  // 合約發放作業/合約發放作業/載入流水號
  npu040200001c: `${BASE_URL}/api-npu040200-001-c`,
  // 合約發放作業/合約發放作業/代書庫存
  npu040200001d: `${BASE_URL}/api-npu040200-001-d`,
  // 合約發放作業/合約發放作業/代書庫存細項
  npu040200001e: `${BASE_URL}/api-npu040200-001-e`,
  // 合約發放作業/合約發放作業/發放
  npu040200003a: `${BASE_URL}/api-npu040200-003-a`,
  // 合約發放作業/合約發放作業/列印簽收單
  npu040200005a: `${BASE_URL}/api-npu040200-005-a`,

  // 合約發放作業/合約檢核作業/查詢合約
  npu041600001a: `${BASE_URL}/api-npu041600-001-a`,
  // 合約發放作業/合約檢核作業/單筆合約細項
  npu041600001b: `${BASE_URL}/api-npu041600-001-b`,
  // 合約發放作業/合約檢核作業/代書庫存
  npu041600001c: `${BASE_URL}/api-npu041600-001-c`,
  // 合約發放作業/合約檢核作業/代書庫存細項
  npu041600001d: `${BASE_URL}/api-npu041600-001-d`,
  // 合約發放作業/合約檢核作業/審核(確認)
  npu041600003a: `${BASE_URL}/api-npu041600-003-a`,

  // 代書資料維護 合約協定書換發日期修改歷程v
  npu030700001a: `${BASE_URL}/api-npu030700-001-a`,
  // 代書資料維護 狀態停用歷程v
  npu030700001b: `${BASE_URL}/api-npu030700-001-b`,
  // 代書資料維護 取得列表資料v
  npu030700getlist: `${BASE_URL}/npu030700/getlist`,
  // 代書資料維護 取得列表資料v
  npu030700getdetails: `${BASE_URL}/npu030700/getdetails`,
  // 代書資料維護 代書助理查詢
  npu030700outusersearch: `${BASE_URL}/npu030700/outusersearch`,
  // 代書資料維護 新增資料
  npu030700002: `${BASE_URL}/api-npu030700-002`,
  // 代書資料維護 修改資料
  npu030700003: `${BASE_URL}/api-npu030700-003`,
  // 代書資料維護 停用
  npu030700003a: `${BASE_URL}/api-npu030700-003-a`,

  // 合約發放作業 合約庫存查詢 取得主要列表資料
  npu040300getmasterlist: `${BASE_URL}/npu040300/getmasterlist`,
  // 合約發放作業 合約庫存查詢 取得明細列表資料
  npu040300getdetaillist: `${BASE_URL}/npu040300/getdetaillist`,
  // 合約發放作業 合約庫存查詢 匯出代書庫存及庫存明細表資料
  npu040300getexportlist1: `${BASE_URL}/npu040300/getexportlist1`,
  // 合約發放作業 合約庫存查詢 匯出倉庫庫存表資料
  npu040300getexportlist2: `${BASE_URL}/npu040300/getexportlist2`,
  // 合約發放作業 合約庫存查詢 取得下拉式選單資料
  npu040300getcontrolllist: `${BASE_URL}/npu040300/getcontrolllist`,

  // 合約發放作業 合約流水號入庫 查詢列表
  npu040100getlist: `${BASE_URL}/api-npu040100/getlist`,
  // 合約發放作業 合約流水號入庫 取得起始流水號
  npu040100getnewcontractid: `${BASE_URL}/api-npu040100/getnewcontractid`,
  // 合約發放作業 合約流水號入庫 整批新增
  npu040100insertbulk: `${BASE_URL}/api-npu040100/insertbulk`,
  // 合約發放作業 合約流水號入庫 刪除
  npu040100delete: `${BASE_URL}/api-npu040100/delete`,

  // 合約發放作業 合約作廢回復 查詢合約
  npu041900search: `${BASE_URL}/api-npu041900/search`,
  // 合約發放作業 合約作廢回復 還原成發放
  npu041900reduction: `${BASE_URL}/api-npu041900/reduction`,

  // 台新支票檔簡訊/承辦窗口列表
  apiChequeUserList: `${BASE_URL}/api-cheque-userlist`,
  // 台新支票檔簡訊/未發訊列表
  apiChequeNonewsLetterlist: `${BASE_URL}/api-cheque-nonewsletterlist`,
  // 台新支票檔簡訊/未確認列表
  apiChequeNochecknewsLetterlist: `${BASE_URL}/api-cheque-nochecknewsletterlist`,
  // 台新支票檔簡訊/明細
  apiChequeDetail: `${BASE_URL}/api-cheque-detail`,
  // 台新支票檔簡訊/人工處理
  apiChequeManualProcessing: `${BASE_URL}/api-cheque-manualprocessing`,
  // 台新支票檔簡訊/不通知
  apiChequeNoNotice: `${BASE_URL}/api-cheque-no-notice`,
  // 台新支票檔簡訊/存檔
  apiChequeArchive: `${BASE_URL}/api-cheque-archive`,
  // 台新支票檔簡訊/確認通知
  apiChequeChecknotify: `${BASE_URL}/api-cheque-checknotify`,

  // 台新支票檔簡訊/專戶資金控管表_完整
  apiChequeSpcaccountfundcontrolTable: `${BASE_URL}/api-cheque-spcaccountfundcontroltable`,

  // 仲介商資料維護 取得列表資料  / 仲介商查詢V
  npu030600001: `${BASE_URL}/api-npu030600-001`,
  // 仲介商資料維護 取得列表下拉選單資料V
  npu030600001b: `${BASE_URL}/api-npu030600-001-b`,
  // 仲介商資料維護 刪除V
  npu030600004: `${BASE_URL}/api-npu030600-004`,
  // 仲介商資料維護 秘書資訊V
  npu030600001f: `${BASE_URL}/api-npu030600-001-f`,
  // 仲介商資料維護 狀態停用歷程V
  npu030600001c: `${BASE_URL}/api-npu030600-001-c`,
  // 仲介商資料維護 合約協定書換發日期修改歷程V
  npu030600001d: `${BASE_URL}/api-npu030600-001-d`,
  // 仲介商資料維護 店長姓名/手機、秘書姓名/手機 修改紀錄V
  npu030600001e: `${BASE_URL}/api-npu030600-001-e`,
  // 仲介商資料維護 取得單一詳細資料及選單 edit V
  npu030600001a: `${BASE_URL}/api-npu030600-001-a`,
  // 仲介商資料維護 exec For 轉招
  npu030600004a: `${BASE_URL}/api-npu030600-004-a`,

  // 仲介商資料維護 新增資料
  npu030600002: `${BASE_URL}/api-npu030600-002`,
  // 仲介商資料維護 修改資料
  npu030600003: `${BASE_URL}/api-npu030600-003`,

  // 匯入行政區資料
  npu031200005a: `${BASE_URL}/api-npu031200-005-a`,

  // 品牌資料維護 查詢列表v
  branddatamaintenancesearchlist: `${BASE_URL}/branddatamaintenance/searchlist`,
  // 品牌資料維護 品牌資料匯出v
  branddatamaintenanceexport: `${BASE_URL}/branddatamaintenance/export`,
  // 品牌資料維護 品牌資料明v
  branddatamaintenancedetails: `${BASE_URL}/branddatamaintenance/details`,
  // 品牌資料維護 修改品牌資料明細
  branddatamaintenanceupdatedetails: `${BASE_URL}/branddatamaintenance/updatedetails`,
  // 品牌資料維護 新增品牌資料
  branddatamaintenanceinsertdetails: `${BASE_URL}/branddatamaintenance/insertdetails`,
  // 品牌資料維護 停用/刪除品牌資料v
  branddatamaintenanceupdatebranddatastatus: `${BASE_URL}/branddatamaintenance/updatebranddatastatus`,
  // 品牌資料維護 信用額度列表v
  branddatamaintenancecreditslist: `${BASE_URL}/branddatamaintenance/creditslist`,
  // 品牌資料維護 歷次收/出款明細查詢v
  branddatamaintenancehistorycollectinoutlist: `${BASE_URL}/branddatamaintenance/historycollectinoutlist`,
  // 品牌資料維護 歷次收/出款明細匯出v
  branddatamaintenancehistorycollectinoutexport: `${BASE_URL}/branddatamaintenance/historycollectinoutexport`,

  // 查詢列表
  brandreturnsearchlist: `${BASE_URL}/brandreturn/searchlist`,
  // 修改
  brandreturnsave: `${BASE_URL}/brandreturn/save`,
  // 新增
  brandreturncreate: `${BASE_URL}/brandreturn/create`,

  // 查詢體系列表
  intermediarysetupsearchlist: `${BASE_URL}/intermediarysetup/searchlist`,
  // 取得體系明細
  intermediarysetupdetails: `${BASE_URL}/intermediarysetup/details`,
  // 修改體系資料
  intermediarysetupsavet: `${BASE_URL}/intermediarysetup/save`,
  // 新增體系資料
  intermediarysetupcreate: `${BASE_URL}/intermediarysetup/create`,
  // 體系資料匯出
  intermediarysetupexport: `${BASE_URL}/intermediarysetup/export`,

  // 取得狀態在使用或停用的績效部門資料
  performancedeplist: `${BASE_URL}/performancedep/list`,
  // 取得部門編號資料明細
  apiperformancedepdetail: `${BASE_URL}/apiperformancedep/detail`,
  // 績效部門編號資料修改
  apiperformancedepedit: `${BASE_URL}/apiperformancedep/edit`,
  // 績效部門資料的excel
  performancedepgetexcel: `${BASE_URL}/performancedep/getexcel`,
  // 績效部門編號資料新增
  apiperformancedepadd: `${BASE_URL}/apiperformancedep/add`,
  // 上層部門API查詢
  performancedepupdepidlist: `${BASE_URL}/performancedep/updepidlist`,

  // 取得內部人員資料 (UserID 、 UserName 、 RoleID 、 Status 為條件) [ 績效部門區域人員 ...]
  commonselectuser: `${BASE_URL}/api-common-selectuser`,
  // 取得區域專戶資料
  npu030800001: `${BASE_URL}/api-npu030800-001`,
  // 已選/未選入鄉鎮列表
  npu030800002: `${BASE_URL}/api-npu030800-002`,
  // 取得公司別列表
  npu030800getcompanylist: `${BASE_URL}/api-npu030800/getcompanylist`,
  // 取得業務/代理人員列表
  npu030800getuserlist: `${BASE_URL}/api-npu030800/getuserlist`,
  // 區域專戶新增
  npu030800insert: `${BASE_URL}/api-npu030800/insert`,
  // 區域專戶修改
  npu030800edit: `${BASE_URL}/api-npu030800/edit`,
  // 區域專戶刪除(停用)
  npu030800delete: `${BASE_URL}/api-npu030800/delete`,

  // 績效部門區域資料維護 取得列表資料
  npu032500001: `${BASE_URL}/api-npu032500-001`,
  // 績效部門區域資料維護 取得單一詳細資料及選單
  npu032500001a: `${BASE_URL}/api-npu032500-001-a`,
  // 績效部門區域資料維護 新增資料
  npu032500002: `${BASE_URL}/api-npu032500-002`,
  // 績效部門區域資料維護 修改資料
  npu032500003: `${BASE_URL}/api-npu032500-003`,

  // 取得品牌體系列表資料
  npu032100001: `${BASE_URL}/api-npu032100-001`,
  // 新增品牌體系資料
  npu032100002: `${BASE_URL}/api-npu032100-002`,
  // 修改品牌體系資料
  npu032100003: `${BASE_URL}/api-npu032100-003`,
  // 取得品牌體系資料(內頁)
  npu032100001aa: `${BASE_URL}/api-npu032100-001-aa`,
  // 取得取得品牌體系列表資料匯出
  npu032100001ab: `${BASE_URL}/api-npu032100-001-ab`,
  // 取得品牌體系之品牌資料
  npu032100001b: `${BASE_URL}/api-npu032100-001-b`,

  // 代書區域列表
  writelegalareagetcategory: `${BASE_URL}/writelegalarea/getcategory`,
  // 取得代書區域資料
  writelegalareagetlist: `${BASE_URL}/writelegalarea/getlist`,
  // 儲存代書區域資
  npu031300002aa: `${BASE_URL}/api-npu031300-002-aa`,

  // 仲介區域列表
  brokerageareagetcategory: `${BASE_URL}/brokeragearea/getcategory`,
  // 取得仲介區域資料
  brokerageareagetlist: `${BASE_URL}/brokeragearea/getlist`,
  // 儲存仲介區域資料
  brokerageareasavelist: `${BASE_URL}/brokeragearea/savelist`,

  // 取得共用參數類別資料
  npu030100001a: `${BASE_URL}/api-npu030100-001-a`,
  // 取得共用參數資料列表
  npu030100001: `${BASE_URL}/api-npu030100-001`,
  // 新增共用參數資料
  npu030100002: `${BASE_URL}/api-npu030100-002`,
  // 修改共用參數資料
  npu030100003: `${BASE_URL}/api-npu030100-003`,
  // 刪除共用參數資料 (實際上是停用)
  npu030100004: `${BASE_URL}/api-npu030100-004`,

  // 取得銀行資料列表
  npu030300001a: `${BASE_URL}/api-npu030300-001-a`,
  // 新增銀行資料
  npu030300002a: `${BASE_URL}/api-npu030300-002-a`,
  // 修改銀行資料
  npu030300003a: `${BASE_URL}/api-npu030300-003-a`,
  // 停用(啟用)銀行資料
  npu030300004a: `${BASE_URL}/api-npu030300-004-a`,
  // 取得分行資料
  npu030300001b: `${BASE_URL}/api-npu030300-001-b`,
  // 新增分行資料
  npu030300002b: `${BASE_URL}/api-npu030300-002-b`,
  // 修改分行資料
  npu030300003b: `${BASE_URL}/api-npu030300-003-b`,
  // 刪除分行資料
  npu030300004b: `${BASE_URL}/api-npu030300-004-b`,
  // 取得活儲/活存資料
  npu030300001c: `${BASE_URL}/api-npu030300-001-c`,
  // 新增活儲/活存資料
  npu030300002c: `${BASE_URL}/api-npu030300-002-c`,
  // 修改活儲/活存資料
  npu030300003c: `${BASE_URL}/api-npu030300-003-c`,
  // 合併作業
  npu030300001ba: `${BASE_URL}/api-npu030300-001-ba`,

  // https://anshinescrow-dev.januarytc.com/Ant_API/api/api-npu031200-003-a
  // 取得縣市資料列表
  npu031200001a: `${BASE_URL}/api-npu031200-001-a`,
  // 取得鄉鎮代碼(最大+1) unuse
  npu031200001aa: `${BASE_URL}/api-npu031200-001-aa`,
  // 刪除縣市資料 (純修改狀態status:N) unuse
  npu031200004a: `${BASE_URL}/api-npu031200-004-a`,
  // 新增縣市資料 unuse
  npu031200002a: `${BASE_URL}/api-npu031200-002-a`,
  // 修改縣市資料 unuse
  npu031200003a: `${BASE_URL}/api-npu031200-003-a`,
  // 取得鄉鎮市區資料列表
  npu031200001b: `${BASE_URL}/api-npu031200-001-b`,
  // 取得鄉鎮代碼(最大+1)
  npu031200001ba: `${BASE_URL}/api-npu031200-001-ba`,
  // 刪除鄉鎮市區資料 (純修改狀態status:N)
  npu031200004b: `${BASE_URL}/api-npu031200-004-b`,
  // 新增鄉鎮市區資料
  npu031200002b: `${BASE_URL}/api-npu031200-002-b`,
  // 修改鄉鎮市區資料
  npu031200003b: `${BASE_URL}/api-npu031200-003-b`,
  // 取得道路資料列表
  npu031200001c: `${BASE_URL}/api-npu031200-001-c`,
  // 取得道路代碼(最大+1)
  npu031200001ca: `${BASE_URL}/api-npu031200-001-ca`,
  // 新增道路資料
  npu031200002c: `${BASE_URL}/api-npu031200-002-c`,
  // 修改道路資料
  npu031200003c: `${BASE_URL}/api-npu031200-003-c`,
  // 刪除道路資料(純修改狀態status:N)
  npu031200004c: `${BASE_URL}/api-npu031200-004-c`,

  // 取得大段資料
  npu031210001a: `${BASE_URL}/api-npu031210-001-a`,
  // 取得小段資料
  npu031210001b: `${BASE_URL}/api-npu031210-001-b`,
  // 新增大段資料
  npu031210002a: `${BASE_URL}/api-npu031210-002-a`,
  // 修改大段資料
  npu031210003a: `${BASE_URL}/api-npu031210-003-a`,
  // 新增小段資料
  npu031210002b: `${BASE_URL}/api-npu031210-002-b`,
  // 修改小段資料
  npu031210003b: `${BASE_URL}/api-npu031210-003-b`,

  // Dashboard資料
  dashBoard: `${BASE_URL}/API-DashBoard`,

  // 取得服務費追蹤資料
  getSerFeeInfoList: `${BASE_URL}/API-SerFee-Info`,
  // 取得服務費追蹤資料Excel
  getSerFeeInfoExcel: `${BASE_URL}/API-SerFee-Excel`,

  // 取得協議動用正本未回追蹤資料
  getAgmTrackingListInfo: `${BASE_URL}/API-AgmTracking-List-Info`,
  // 取得協議動用正本未回追蹤資料Excel
  getAgmTrackingExcel: `${BASE_URL}/API-AgmTracking-List-Excel`,
  // 取得協議動用正本未回追蹤歷史紀錄資料
  getAgmTrackingDetailRecode: `${BASE_URL}/API-AgmTracking-Detail-Recode`,
  // 取得業務查詢資料
  getAgmTrackingSales: `${BASE_URL}/API-AgmTracking-Sales`,
  // 從群組取得使用者清單
  getGetGroupUserList: `${BASE_URL}/API-GetGroupUserList`,
  // 修改資料紀錄資料
  sendAgmTrackingDetailEdit: `${BASE_URL}/API-AgmTracking-Detail-Edit`,
  // 取得動用正本未回追蹤統計資料
  getNonAgmTrackingStatistics: `${BASE_URL}/API-Non-AgmTracking-Statistics`,

  // 未入動用追蹤
  // 取得未入動用追蹤-判定風險等級資料
  getUnusedTrackingList: `${BASE_URL}/API-UnusedTracking-U-List-Info`,
  // 取得未入動用追蹤-判定風險等級資料Excel
  getUnusedTrackingExcel: `${BASE_URL}/API-UnusedTracking-U-List-Excel`,
  // 取得未入動用追蹤-判定風險等級編輯紀錄資料
  getUnusedTrackingLog: `${BASE_URL}/API-UnusedTracking-U-Log`,
  // 修改未入動用追蹤-判定風險等級資料
  getUnusedTrackingEdit: `${BASE_URL}/API-UnusedTracking-U-Edit`,

  // 取得未入動用追蹤-風險案件回報
  getUnusedTrackingRListInfo: `${BASE_URL}/API-UnusedTracking-R-List-Info`,
  // 取得未入動用追蹤-風險案件回報Excel
  getUnusedTrackingRListExcel: `${BASE_URL}/API-UnusedTracking-R-List-Excel`,
  // 取得未入動用追蹤-風險案件回報編輯紀錄資料
  getUnusedTrackingRLog: `${BASE_URL}/API-UnusedTracking-R-Log`,
  // 修改未入動用追蹤-風險案件回報資料
  getUnusedTrackingREdit: `${BASE_URL}/API-UnusedTracking-R-Edit`,

  // 取得未入動用追蹤-法務處理資料
  getUnusedTrackingLListInfo: `${BASE_URL}/API-UnusedTracking-L-List-Info`,
  // 取得未入動用追蹤-法務處理資料Excel
  getUnusedTrackingLListExcel: `${BASE_URL}/API-UnusedTracking-L-List-Excel`,
  // 修改未入動用追蹤-法務處理資料
  getUnusedTrackingLListEdit: `${BASE_URL}/API-UnusedTracking-L-Edit`,
  // 取得未入動用追蹤-法務處理編輯紀錄資料
  getUnusedTrackingLListLog: `${BASE_URL}/API-UnusedTracking-L-Log`,

  // 取得區域資料
  getCommonAccountNum: `${BASE_URL}/API-Common-AccountNum`,

  // 得電訪紀錄總攬
  getTellVGetList: `${BASE_URL}/API-TellV-GetList`,
  // 取得電訪紀錄Excel
  getAPITellVExcel: `${BASE_URL}/API-TellV-Excel`,
  // 編輯電訪紀錄
  rellVEdit: `${BASE_URL}/API-TellV-Edit`,
  // 取得電訪編輯紀錄
  rellVGetLog: `${BASE_URL}/API-TellV-GetLog`,

  // 取得案件追蹤盤點資料
  getCaseTrackingListInfo: `${BASE_URL}/API-CaseTracking-List-Info`,
  // 取得案件追蹤盤點資料Excel
  getCaseTrackingExcel: `${BASE_URL}/API-CaseTracking-Excel`,

  // 盤點案件
  setCaseTrackingAudited: `${BASE_URL}/API-CaseTracking-AuditedWithTelIV`,

  // 取得報表排程資料
  getReportSetScheduleList: `${BASE_URL}/API-ReportSetSchedule-List`,
  // 新增報表排程資料
  getReportSetScheduleAdd: `${BASE_URL}/API-ReportSetSchedule-Add`,
  // 修改報表排程資料
  getReportSetScheduleEdit: `${BASE_URL}/API-ReportSetSchedule-Edit`,
  // 刪除報表排程資料
  getReportSetScheduleDelete: `${BASE_URL}/API-ReportSetSchedule-Del`,

  // 取得保證書套印資料
  getWarrantyOverprintList: `${BASE_URL}/API-WarrantyOverprint-List`,
  // 保證書套印檔案下載
  warrantyOverprintDownload: `${BASE_URL}/API-WarrantyOverprint-Download`,
  // 保證書套印檔案上傳
  warrantyOverprintUpload: `${BASE_URL}/API-WarrantyOverprint-Upload`,
  // 保證書難字上傳檔案下載
  warrantyOverprintDownloadOut: `${BASE_URL}/API-WarrantyOverprint-DownloadOut`,

  // 住商 查詢合約列表
  getCDTReadList: `${BASE_URL}/mm/API-CDT-ReadList`,
  getCDTReaddetail: `${BASE_URL}/mm/API-CDT-Read`,
  deleteCDTReaddetail: `${BASE_URL}/mm/API-CDT-Update-Status`,
  sentCDTReaddetail: `${BASE_URL}/mm/API-CDT-UpdateOld`,

  dashboardCheck: `${BASE_URL}/API-User-Permission`,

  // 查詢自動壓縮檔案紀錄
  GetAutoZipLog: `${BASE_URL}/GetAutoZipLog`,
  // 查詢主機收出款異常通知紀錄
  GetLogAnalyzerAlert: `${BASE_URL}/GetLogAnalyzerAlert`,

  // 取得詞彙資料
  getVocabularyList: `${BASE_URL}/API-Vocabulary-List`,
  // 新增詞彙資料
  VocabularyAdd: `${BASE_URL}/API-Vocabulary-Add`,
  // 修改詞彙資料
  VocabularyEdit: `${BASE_URL}/API-Vocabulary-Edit`,
  // 刪除詞彙資料
  VocabularyDelete: `${BASE_URL}/API-Vocabulary-Del`,

  // 身份驗證
  // 身分證OCR辨識API
  recognizeidcard: `${BASE_URL}/idcheck/recognizeidcard`,

  // "暫存未驗證"身分證辨識資料儲存
  idcheckTempAddition: `${BASE_URL}/idcheck/tempaddition`,

  // 取得暫存未經過驗證的身分證資料
  getOCRTempData: `${BASE_URL}/idcheck/getocrtempdata`,
};

export default ApiUrl;
